import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Loader from "./Loader";
import { Link } from "react-router-dom";
import "../Assets/Css/CourseList.css";
import tempChapter from "../Assets/Json/tempChapter.json";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import { useLocation } from "react-router-dom";
import fallbackThumbnail from "../Assets/Images/Chapters/img-placeholder.png"

const VideoListing = () => {
  // console.log(" : ", tempChapter[0]);
  const [syllabus, setSyllabus] = useState(tempChapter);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { videos } = location.state || { videos: [] };
  const chapter_id = location.state.chapter_id || null;
  const chapter_name = location.state.chapter_name || " ";
  const chapter_desc = location.state.chapter_desc || " ";
  const grade  = location.state.grade || " ";

  const [searchInput, setSearchInput] = useState("");

  const [results, setResults] = useState(videos);
  // console.log("videos: ",results);

  useEffect(() => {
    if (searchInput.trim() === "") {
      setResults(videos); // Reset results to the full list
    } else {
      const filteredData = results.filter((data, ind) => {
        const lowercaseSearchInput = searchInput.toLowerCase();
        const videoNumber = (ind + 1).toString(); // Dynamically calculate the video number
        return (
          videoNumber.includes(lowercaseSearchInput) || // Search by video number
          (data?.video.vid_title &&
            data?.video.vid_title.toLowerCase().includes(lowercaseSearchInput))
        );
      });

      setResults(filteredData);
    }
  }, [syllabus, searchInput]);

  // useEffect(() => {
  //   const filteredData = results.filter((data,ind) => {
  //     const lowercaseSearchInput = searchInput.toLowerCase();
  //     return (
  //       lowercaseSearchInput === "" ||
  //       (data.chapter_no &&
  //         data.chapter_no.toString().includes(lowercaseSearchInput)) ||
  //       (data.video.vid_title &&
  //         data.video.vid_title.toLowerCase().includes(lowercaseSearchInput))

  //     );

  //   });

  //   setResults(filteredData);
  // }, [syllabus, searchInput]);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            {/*  */}
            <div className="row me-4 mt-4 mb-2">
              {/* <div className="col-lg-9 col-12">
                <p className="admin_title">Chapters</p>
              </div> */}
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <Link
                    to="/courses"
                    className="prevPage"
                    state={{
                      // videos: data.videos,
                      chapter_id: chapter_id,
                      chapter_name: chapter_name,
                      selectedGrade: grade,
                    }}
                  >
                    {chapter_name}
                  </Link>
                  {/* <img
                  src={nextArrow}
                  alt="nextArrow"
                  height={40}
                  className="mt-1"
                />
                <p className="currentPage">{}</p> */}
                </ol>
              </nav>
              <p className="chapter_desc_heading">{chapter_desc}</p>
              <div className="col-lg-9 col-12">
                <p className="admin_title">Videos</p>
              </div>
              {/* <div className="col-lg-3 col-6 mt-4">
                <Select
                  options={grades}
                  value={selectedGrade}
                  onChange={(option) => setSelectedGrade(option)}
                  placeholder="Filter by Grade"
                />
              </div> */}
              <div className="col-lg-3 col-12 mt-4">
                <input
                  type="search"
                  className="form-control search-input"
                  placeholder="Search"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                />
              </div>
            </div>

            {isLoading ? (
              <div>
                <Loader />
              </div>
            ) : (
              <>
                {/* syllabus */}
                {results.length <= 0 && (
                  <div className="text-center noDataContainer">
                    <div className="noData">No data available</div>
                  </div>
                )}
                {results.length > 0 && (
                  <div className="row row-col-auto">
                    {results.map((data, ind) => {
                       const thumbnail =
                       data?.video?.vid_thumbnail || fallbackThumbnail; // Use fallback image
                    //  console.log("Thumbnail URL: ", thumbnail); 
                      return (
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 col-12"
                          key={ind}
                        >
                          <div className="mb-5 me-2">
                            <Link
                              to="/courses/videosList/videos"
                              style={{
                                color: "black",
                                textDecoration: "none",
                              }}
                              state={{
                                // videos: data.videos,

                                chapter_id: chapter_id,
                                chapter_name: chapter_name,
                                chapter_desc:chapter_desc,
                                videoData: data.video,
                                videos:videos,
     
                              }}
                            >
                              <>
                                {data?.video?.vid_thumbnail === "" ||
                                data?.video?.vid_thumbnail === null ? (
                                  <div className="blur_img">
                                    <img
                                      src=""
                                      alt="courses_img"
                                      className="Syllabus_Images"
                                      style={{ borderRadius: "16px",height:"203px" }}
                                    />
                                  </div>
                                ) : (
                                  <div className="blur_img">
                                    <img
                                      src={thumbnail}
                                      alt="courses_img"
                                      onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = fallbackThumbnail; // Fallback if the image fails to load
                                      }}
                                      className="Syllabus_Images"
                                      style={{ borderRadius: "16px",height:"203px"  }}
                                    />
                                  </div>
                                )}

                                <div className="chapter_desc">
                                  <p className="chapter_number">{`Video ${
                                    ind + 1
                                  }`}</p>
                                  <p className="chapter_title">
                                    {data?.video?.vid_title}
                                  </p>
                                </div>
                              </>
                            </Link>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {results.length === 0 && searchInput !== "" && (
                  <div className="noDataContainer">
                    <div className="text-center noData">No data available</div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default VideoListing;
